<app-loader *ngIf="isLoading" class="loader"></app-loader>


<!-- Heading that changes based on the breadcrumb -->
<div *ngIf="!isMobile" id="topDesktop" class="form-heading">
  <h4>{{ currentHeading }}</h4>
  <div class="heading-border"></div>
</div>


<!-- Multi-Step Form -->
<form [formGroup]="form" id="topMobile" (ngSubmit)="onSubmit()" class="responsive-form" autocomplete="off">
  <div class="container">
    <div class="row">
      <!-- Step 1 -->
      <div *ngIf="currentStep === 0" class="col-12" formGroupName="section1">
        <div class="form-section row">
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown field">

            <input id="date_of_accident" formControlName="date_of_accident" placeholder="Date of Accident" type="date"
              [max]="maxDate" class="form-control" />
            <label class="form__label" for="date_of_accident">Date of Accident &nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section1.date_of_accident')?.invalid && form.get('section1.date_of_accident')?.touched">
              Enter date of accident
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown field">
            <input id="time_of_accident" style="cursor: text;" formControlName="time_of_accident"
              placeholder="Date of Accident" type="time" class="form-control time"
              (change)="onTimeChange($event,'section1')" />
            <label class="form__label" for="time_of_accident">Time of Accident &nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section1.time_of_accident')?.invalid && form.get('section1.time_of_accident')?.touched">
              Enter Time of Accident
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="vehicle_year">Vehicle Year &nbsp;<span style="color:red">*</span></label>
            <div class="select">
              <select id="vehicle_year" formControlName="vehicle_year">
                <option disabled [value]="">Select vehicle year</option>
                <option *ngFor="let year of yearList" [value]="year">{{ year }}</option>
              </select>
            </div>
            <div class="error-msg"
              *ngIf="form.get('section1.vehicle_year')?.invalid && form.get('section1.vehicle_year')?.touched">
              Enter vehicle year
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-4 col-md-4 col-12 form-group">

            <input id="make" formControlName="make" placeholder="Make" type="email" class="form-control" />
            <label class="form__label" for="make">Make</label>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">

            <input id="model" formControlName="model" placeholder="Model" type="email" class="form-control" />
            <label class="form__label" for="model">Model</label>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">

            <input id="license_plate_number" formControlName="license_plate_number" placeholder="License Plate Number"
              type="text" class="form-control" />
            <label class="form__label" for="license_plate_number">License Plate Number</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-6 col-md-6 col-12 form-group">

            <input id="vehicle_number" formControlName="vehicle_number" placeholder="Vehicle Identification Number"
              type="email" class="form-control" />
            <label class="form__label" for="vehicle_number">Vehicle Identification Number</label>
          </div>
          <div class="col-lg-6 col-md-6 col-12 form-group form-group-dropdown">
            <label class="form__label" for="state_vechicle_registered">State Vehicle is Registered in</label>
            <div class="select">
              <select id="state" formControlName="state_vechicle_registered">
                <option disabled [value]="">Select state</option>
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">

            <input id="address" formControlName="address" placeholder="Address/Location of Accident" type="textarea"
              class="form-control" />
            <label class="form__label" for="address">Address/Location of Accident</label>
          </div>
        </div>
        <div class="form-section row">

          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="state">State<span style="color:red">*</span></label>
            <div class="select">
              <select id="state" formControlName="state">
                <option disabled [value]="">Select state</option>
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
            <div class="error-msg" *ngIf="form.get('section1.state')?.invalid && form.get('section1.state')?.touched">
              Enter state
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="county">County<span style="color:red">*</span></label>
            <div class="select">
              <select id="county" formControlName="county">
                <option disabled [value]="">Select county</option>
                <option *ngFor="let county of countyMap['counties']" [value]="county.county_name"> {{ county.county_name
                  }}</option>
              </select>
            </div>
            <div class="error-msg" *ngIf="form.get('section1.county')?.invalid && form.get('section1.county')?.touched">
              Enter county
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="vehicle_year">City<span style="color:red">*</span></label>
            <div class="select">
              <select id="city" formControlName="city">
                <option disabled [value]="">Select city</option>
                <option *ngFor="let city of  cityMap['cities']" [value]="city"> {{ city }}</option>
              </select>
            </div>
            <div class="error-msg" *ngIf="form.get('section1.city')?.invalid && form.get('section1.city')?.touched">
              Enter city
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="zip_code" formControlName="zip_code" placeholder="Zip Code" type="email" class="form-control" />
            <label class="form__label" for="zip_code">Zip Code</label>
          </div>
          <div class="col-lg-6 col-md-6 col-12 form-group form-group-dropdown">
            <label class="form__label" for="vehicles_involved">Number of Vehicles involved</label>
            <div class="select">
              <select id="vehicles_involved" formControlName="vehicles_involved">
                <option disabled [value]="">Select vehicles involved</option>
                <option *ngFor="let number of  numberOfVehiclesInvolved" [value]="number"> {{ number }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-6 col-md-5 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Vehicle was:</label>
              <div class="checkbox-container">
                <label *ngFor="let vehicle of vehicleState" class="checkbox-item">
                  <input type="radio" formControlName="vehicle_state" [value]="vehicle.value" /> &nbsp;
                  {{ vehicle.label }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-7 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Involved in the Accident:</label>
              <div class="checkbox-container">
                <label *ngFor="let type of involvedINAccidentType" class="checkbox-item">
                  <input type="radio" formControlName="accident_involved" [value]="type.value"
                    (click)="checkForOther(type.label)" /> &nbsp;
                  {{ type.label }}
                </label>
              </div>
              <div *ngIf="!isMobile" style="max-width: 20%;" class="custom-other-input">
                <input type="text" [class.other_input_highlight]="isOtherAccTypeSelected"
                  [readOnly]="!isOtherAccTypeSelected"
                  [ngStyle]="{'cursor': isOtherAccTypeSelected == false ? 'not-allowed' : 'text'}" id="other_type"
                  style="padding: 0;" formControlName="other_type" class="form-control">
              </div>
            </div>
            <div *ngIf="isMobile">
              <input type="text" [class.other_input_highlight]="isOtherAccTypeSelected"
                [readOnly]="!isOtherAccTypeSelected"
                [ngStyle]="{'cursor': isOtherAccTypeSelected == false ? 'not-allowed' : 'text'}" id="other_type"
                style="padding: 0;" formControlName="other_type" class="form-control custom-other-input">
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">
            <input id="driver_name" formControlName="driver_name" placeholder="Driver's Full Name (First,Middle,Last)"
              type="text" class="form-control" />
            <label class="form__label" for="driver_name">Driver's Full Name (First,Middle,Last)</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="driver_license_number" formControlName="driver_license_number"
              placeholder="Driver License Number" type="email" class="form-control" />
            <label class="form__label" for="driver_license_number">Driver License Number</label>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="driver_state">State</label>
            <div class="select">
              <select id="driver_state" formControlName="driver_state">
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <input id="date_of_birth" formControlName="date_of_birth" placeholder="Date of Birth" type="date"
              [max]="maxDate" class="form-control" />
            <label class="form__label" for="date_of_birth">Date of Birth&nbsp;<span
              style="color:red">*</span></label>
              <div class="error-msg"
              *ngIf="form.get('section1.date_of_birth')?.invalid && form.get('section1.date_of_birth')?.touched">
              Enter Date of Birth
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">
            <input id="insurance_company" formControlName="insurance_company"
              placeholder="Insurance Company Name or Surety Company at time of Accident" type="email"
              class="form-control label-extra-margin" />
            <label class="form__label" for="insurance_company">Insurance Company Name or Surety Company at time of
              Accident&nbsp;<span style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section1.insurance_company')?.invalid && form.get('section1.insurance_company')?.touched">
              Enter Insurance Company Name or Surety Company at time of Accident
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-3 col-md-3 col-12 form-group">
            <input id="policy_number" formControlName="policy_number" placeholder="Policy Number" type="email"
              class="form-control" />
            <label class="form__label" for="policy_number">Policy Number&nbsp;<span style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section1.policy_number')?.invalid && form.get('section1.policy_number')?.touched">
              Enter Policy Number
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12 form-group">
            <input id="naic_number" formControlName="naic_number" placeholder="Company NAIC Number" type="email"
              class="form-control" />
            <label class="form__label" for="naic_number">Company NAIC Number</label>
          </div>
          <div class="col-lg-3 col-md-3 col-12 form-group form-group-dropdown">
            <input id="policy_period_from" formControlName="policy_period_from" placeholder="Policy Period" type="date"
              class="form-control" />
            <label class="form__label" for="policy_period_from">Policy Period From &nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section1.policy_period_from')?.invalid && form.get('section1.policy_period_from')?.touched">
              Enter Policy Period From
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12 form-group form-group-dropdown">
            <input id="policy_period_to" formControlName="policy_period_to" placeholder="Policy Period" type="date"
              class="form-control" />
            <label class="form__label" for="policy_period_to">Policy Period To &nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section1.policy_period_to')?.invalid && form.get('section1.policy_period_to')?.touched">
              Enter Policy Period To
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Describe vehicle damage:</label>
              <div class="custom-checkbox-container" style="gap: 50px;">
                <label *ngFor="let type of vehicleDamageType" class="checkbox-item">
                  <input type="radio" formControlName="DESC_VEH_DAM" [value]="type.value" />&nbsp;
                  {{ type.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-navigation">
          <button type="button" (click)="nextStep()" class="btn btn-primary btn-next">Next</button>
        </div>
      </div>

      <!-- Step 2 -->
      <div *ngIf="currentStep === 1" formGroupName="section2">
        <div class="card car-damage-card">
          <div class="card-body">
            <div class="car-container">
              <!-- Back Label -->
              <div class="car-label back-label">Back</div>

              <!-- Car Structure -->
              <div class="car-grid">
                <div *ngFor="let row of carStructure2; let rowIndex = index" class="car-row">
                  <div *ngFor="let cell of row; let colIndex = index" class="car-cell" [ngClass]="{
                      'hidden': cell.cellValue === 0,
                      'border-top': cell.cellValue === 2,
                      'border-left': cell.cellValue === 4,
                      'border-right': cell.cellValue === 5,
                      'border-bottom': cell.cellValue === 3 ,
                      'border-top_left': cell.cellValue === 6,
                      'border-top_right': cell.cellValue === 7,
                      'border-bottom_left': cell.cellValue === 8,
                      'border-bottom_right': cell.cellValue === 9,
                      'border-leftmore-bottom': cell.cellValue === 10,
                      'border-leftright-top': cell.cellValue === 11,
                      'border-top-middle-rotate':cell.cellValue === 13,
                      'border-bottom-middle-rotate': cell.cellValue === 12,
                      'border-top-leftrotate': cell.cellValue === 14,
                      'border-bottom-leftrotate': cell.cellValue === 15,
                      'top-lefthalf-background-black': (colIndex === 2 || colIndex === 6 ) && (rowIndex === 0),
                      'top-righthalf-background-black': (colIndex === 1 || colIndex === 5 ) && (rowIndex === 0),
                      'bottom-lefthalf-background-black': (colIndex === 2 || colIndex === 6) && (rowIndex === 3),
                      'bottom-righthalf-background-black': (colIndex === 1 || colIndex === 2 || colIndex === 5 || colIndex === 6) && (rowIndex === 3),
                      'margin-top-adjust': colIndex === 0 || colIndex === row.length - 1,
                    }">
                    <!-- Render checkbox only for 1 or 2 -->
                    <input *ngIf="cell.cellValue !== 0" id="cell.label" type="checkbox" name="cell.label"
                      [checked]="cell.isChecked"
                      (change)="onShadedCheckBoxChange($event,rowIndex,colIndex,cell.label,'carStructure2','section2','Shaded_Damage_Area')" />
                  </div>
                </div>
              </div>
              <!-- Front Label -->
              <div class="car-label front-label">Front</div>

            </div>
          </div>
        </div>


        <div class="form-navigation">
          <button type="button" (click)="prevStep()" class="btn btn-secondary btn-prev">Previous</button>
          <button type="button" (click)="nextStep()" class="btn btn-primary btn-next"
            style="margin-left:25px">Next</button>
        </div>
      </div>

      <!-- Step 3 -->
      <div *ngIf="currentStep === 2" class="col-12" formGroupName="section3">
        <div class="form-section row">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <label class="form__label" for="veh2_vehicle_year">Vehicle Year</label>
            <div class="select">
              <select id="veh2_vehicle_year" formControlName="veh2_vehicle_year">
                <option disabled [value]="">Select vehicle year</option>
                <option *ngFor="let year of yearList" [value]="year">{{ year }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="veh2_model" formControlName="veh2_model" placeholder="Model" type="email" class="form-control" />
            <label class="form__label" for="veh2_model">Make and Model name</label>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="veh2_license_plate_number" formControlName="veh2_license_plate_number"
              placeholder="License Plate Number" type="text" class="form-control" />
            <label class="form__label" for="veh2_license_plate_number">License Plate Number</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="veh2_vehicle_number" formControlName="veh2_vehicle_number"
              placeholder="Vehicle Identification Number" type="email" class="form-control" />
            <label class="form__label" for="veh2_vehicle_number">Vehicle Identification Number</label>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="veh2_state_vechicle_registered">State Vehicle is Registered in</label>
            <div class="select">
              <select id="veh2_state_vechicle_registered" formControlName="veh2_state_vechicle_registered">
                <option disabled [value]="">Select state</option>
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>

          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="veh2_vehicles_involved">Number of Vehicles involved</label>
            <div class="select">
              <select id="veh2_vehicles_involved" formControlName="veh2_vehicles_involved">
                <option disabled [value]="">Select vehicles involved</option>
                <option *ngFor="let number of  numberOfVehiclesInvolved" [value]="number"> {{ number }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-6 col-md-5 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Vehicle was:</label>
              <div class="checkbox-container">
                <label *ngFor="let vehicle of vehicleState" class="checkbox-item">
                  <input type="radio" formControlName="veh2_vehicle_state" [value]="vehicle.value" /> &nbsp;
                  {{ vehicle.label }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-7 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Involved in the Accident:</label>
              <div class="checkbox-container">
                <label *ngFor="let type of involvedINAccidentType" class="checkbox-item">
                  <input type="radio" formControlName="veh2_accident_involved" [value]="type.value"
                    (click)="checkForOther(type.label)" /> &nbsp;
                  {{ type.label }}
                </label>
              </div>
              <div *ngIf="!isMobile" style="max-width: 20%;" class="custom-other-input">
                <input type="text" [class.other_input_highlight]="isOtherAccTypeSelected"
                  [readOnly]="!isOtherAccTypeSelected"
                  [ngStyle]="{'cursor': isOtherAccTypeSelected == false ? 'not-allowed' : 'text'}" id="other_type"
                  style="padding: 0;" formControlName="veh2_other_type" class="form-control">
              </div>
            </div>
            <div *ngIf="isMobile">
              <input type="text" [class.other_input_highlight]="isOtherAccTypeSelected"
                [readOnly]="!isOtherAccTypeSelected"
                [ngStyle]="{'cursor': isOtherAccTypeSelected == false ? 'not-allowed' : 'text'}" id="other_type"
                style="padding: 0;" formControlName="veh2_other_type" class="form-control custom-other-input">
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">
            <input id="veh2_driver_name" formControlName="veh2_driver_name"
              placeholder="Driver's Full Name (First,Middle,Last)" type="text" class="form-control" />
            <label class="form__label" for="veh2_driver_name">Driver's Full Name (First,Middle,Last)</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="veh2_driver_license_number" formControlName="veh2_driver_license_number"
              placeholder="Driver License Number" type="email" class="form-control" />
            <label class="form__label" for="veh2_driver_license_number">Driver License Number</label>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="veh2_driver_state">State</label>
            <div class="select">
              <select id="veh2_driver_state" formControlName="veh2_driver_state">
                <option disabled [value]="">Select state</option>
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <input id="veh2_date_of_birth" formControlName="veh2_date_of_birth" placeholder="Date of Birth" type="date"
              [max]="maxDate" class="form-control" />
            <label class="form__label" for="veh2_date_of_birth">Date of Birth&nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section3.veh2_date_of_birth')?.invalid && form.get('section3.veh2_date_of_birth')?.touched">
              Enter Date of Birth
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group ">
            <input id="veh2_insurance_company" formControlName="veh2_insurance_company"
              placeholder="Insurance Company Name or Surety Company at time of Accident" type="email"
              class="form-control label-extra-margin" />
            <label class="form__label" for="veh2_insurance_company">Insurance Company Name or Surety Company at time of
              Accident&nbsp;<span style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section3.veh2_insurance_company')?.invalid && form.get('section3.veh2_insurance_company')?.touched">
              Enter Insurance Company Name or Surety Company at time of Accident
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-3 col-md-3 col-12 form-group">
            <input id="veh2_policy_number" formControlName="veh2_policy_number" placeholder="Policy Number" type="email"
              class="form-control" />
            <label class="form__label" for="veh2_policy_number">Policy Number&nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section3.veh2_policy_number')?.invalid && form.get('section3.veh2_policy_number')?.touched">
              Enter Policy Number
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12 form-group">
            <input id="veh2_naic_number" formControlName="veh2_naic_number" placeholder="Company NAIC Number"
              type="email" class="form-control" />
            <label class="form__label" for="veh2_naic_number">Company NAIC Number</label>
          </div>
          <div class="col-lg-3 col-md-3 col-12 form-group form-group-dropdown">
            <input id="veh2_policy_period_from" formControlName="veh2_policy_period_from" placeholder="Policy Period"
              type="date" class="form-control" />
            <label class="form__label" for="veh2_policy_period_from">Policy Period From &nbsp;<span
                style="color:red">*</span></label>
            <div class="error-msg"
              *ngIf="form.get('section3.veh2_policy_period_from')?.invalid && form.get('section3.veh2_policy_period_from')?.touched">
              Enter Policy Period From
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12 form-group form-group-dropdown">
            <input id="veh2_policy_period_to" formControlName="veh2_policy_period_to" placeholder="Policy Period"
              type="date" class="form-control" />
            <label class="form__label" for="veh2_policy_period_to">Policy Period To &nbsp;<span
                style="color:red">*</span> </label>
            <div class="error-msg"
              *ngIf="form.get('section3.veh2_policy_period_to')?.invalid && form.get('section3.veh2_policy_period_to')?.touched">
              Enter Policy Period From
            </div>
          </div>
        </div>
        <div class="form-navigation">
          <button type="button" (click)="prevStep()" class="btn btn-secondary btn-prev">Previous</button>
          <button type="button" (click)="nextStep()" class="btn btn-primary btn-next"
            style="margin-left:25px">Next</button>
        </div>
      </div>

      <!-- Step 4 -->
      <div *ngIf="currentStep === 3" class="col-12" formGroupName="section4">
        <div class="form-section row">
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_person1_name" formControlName="sec4_person1_name" placeholder="Model" type="email"
              class="form-control" />
            <label class="form__label" for="sec4_person1_name">Name (First,Middle,Last)</label>
          </div>
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_person1_address" formControlName="sec4_person1_address" placeholder="Address" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_person1_address">Address</label>
          </div>
        </div>
        <div class="form-section row customRowMrgMobile">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <label class="form__label" for="sec4_person1_state">State</label>
            <div class="select">
              <select id="sec4_person1_state" formControlName="sec4_person1_state">
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="sec4_person1_city">City</label>
            <div class="select">
              <select id="sec4_person1_city" formControlName="sec4_person1_city">
                <option *ngFor="let city of cityMap['sec4P1Cities']" [value]="city"> {{ city }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="sec4_person1_zipcode" formControlName="sec4_person1_zipcode" placeholder="zip code" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_person1_zipcode">Zip Code</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Check all that apply:</label>
              <div class="custom-checkbox-container" style="gap: 50px;">
                <label *ngFor="let type of P1InjuryType; let i=index" class="checkbox-item">
                  <input type="checkbox" id="index" name="type.label" [checked]="type.isChecked"
                    (change)="onCheckboxChange($event,i,type.label,'P1InjuryType','section4','sec4_person1_injurytype')" />&nbsp;
                  {{ type.label }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section row">
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_person2_name" formControlName="sec4_person2_name" placeholder="Model" type="email"
              class="form-control" />
            <label class="form__label" for="sec4_person2_name">Name (First,Middle,Last)</label>
          </div>
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_person2_address" formControlName="sec4_person2_address" placeholder="Address" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_person2_address">Address</label>
          </div>
        </div>
        <div class="form-section row customRowMrgMobile">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <label class="form__label" for="sec4_person2_state">State</label>
            <div class="select">
              <select id="sec4_person2_state" formControlName="sec4_person2_state">
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="sec4_person2_city">City</label>
            <div class="select">
              <select id="sec4_person2_city" formControlName="sec4_person2_city">
                <option *ngFor="let city of cityMap['sec4P2Cities']" [value]="city"> {{ city }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="sec4_person2_zipcode" formControlName="sec4_person2_zipcode" placeholder="zip code" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_person2_zipcode">Zip Code</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-12 col-md-12 col-12 form-group">
            <div class="form-row">
              <label class="main-checkbox-label">Check all that apply:</label>
              <div class="custom-checkbox-container" style="gap: 50px;">
                <label *ngFor="let type of P2InjuryType;let i=index" class="checkbox-item">
                  <input type="checkbox" id="index" name="type.label" [checked]="type.isChecked"
                    (change)="onCheckboxChange($event,i,type.label,'P2InjuryType','section4','sec4_person2_injurytype')" />&nbsp;
                  {{ type.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_property_damage" formControlName="sec4_property_damage" placeholder="Model" type="email"
              class="form-control" />
            <label class="form__label" for="sec4_property_damage">Property Damage</label>
          </div>
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_property_owner_name" formControlName="sec4_property_owner_name" placeholder="Address"
              type="text" class="form-control" />
            <label class="form__label" for="sec4_property_owner_name">Property Owner's Name</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-6 col-md-6 col-12 form-group form-group-dropdown">
            <input id="sec4_property_owner_number" formControlName="sec4_property_owner_number" placeholder="number"
              type="text" class="form-control" (input)="enforcePrefix($event,'sec4_property_owner_number')"
              (keydown)="onKeyDown($event)" />
            <label class="form__label" for="sec4_property_owner_number">Telephone Number</label>
          </div>
          <div class="col-lg-6 col-md-6 col-12 form-group">
            <input id="sec4_property_owner_street_address" formControlName="sec4_property_owner_street_address"
              placeholder="Address" type="text" class="form-control" />
            <label class="form__label" for="sec4_property_owner_street_address">Street Address</label>
          </div>
        </div>
        <div class="form-section row customRowMrgMobile">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <label class="form__label" for="sec4_property_owner_state">State</label>
            <div class="select">
              <select id="sec4_property_owner_state" formControlName="sec4_property_owner_state">
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="sec4_property_owner_city">City</label>
            <div class="select">
              <select id="sec4_property_owner_city" formControlName="sec4_property_owner_city">
                <option *ngFor="let city of cityMap['sec4PropOwnCities']" [value]="city"> {{ city }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="sec4_property_owner_zipcode" formControlName="sec4_property_owner_zipcode" placeholder="zip code"
              type="text" class="form-control" />
            <label class="form__label" for="sec4_property_owner_zipcode">Zip Code</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-5 col-md-5 col-12 form-group">
            <input id="sec4_witness1_name" formControlName="sec4_witness1_name" placeholder="Model" type="email"
              class="form-control" />
            <label class="form__label" for="sec4_witness1_name">Witness Name</label>
          </div>
          <div class="col-lg-5 col-md-5 col-12 form-group">
            <input id="sec4_witness1_address" formControlName="sec4_witness1_address" placeholder="Address" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_witness1_address">Street Address</label>
          </div>
          <div class="col-lg-2 col-md-2 col-12 form-group form-group-dropdown">
            <input id="sec4_witness1_number" formControlName="sec4_witness1_number" placeholder="Model" type="text"
              class="form-control" (input)="enforcePrefix($event,'sec4_witness1_number')"
              (keydown)="onKeyDown($event)" />
            <label class="form__label" for="sec4_witness1_number">Telephone Number</label>
          </div>
        </div>
        <div class="form-section row customRowMrgMobile">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <label class="form__label" for="sec4_witness1_state">State</label>
            <div class="select">
              <select id="sec4_witness1_state" formControlName="sec4_witness1_state">
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="sec4_witness1_city">City</label>
            <div class="select">
              <select id="sec4_witness1_city" formControlName="sec4_witness1_city">
                <option *ngFor="let city of cityMap['sec4W1Cities']" [value]="city"> {{ city }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="sec4_witness1_zipcode" formControlName="sec4_witness1_zipcode" placeholder="zip code" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_witness1_zipcode">Zip Code</label>
          </div>
        </div>
        <div class="form-section row">
          <div class="col-lg-5 col-md-5 col-12 form-group">
            <input id="sec4_witness2_name" formControlName="sec4_witness2_name" placeholder="Model" type="email"
              class="form-control" />
            <label class="form__label" for="sec4_witness2_name">Witness Name</label>
          </div>
          <div class="col-lg-5 col-md-5 col-12 form-group">
            <input id="sec4_witness2_address" formControlName="sec4_witness2_address" placeholder="Address" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_witness2_address">Street Address</label>
          </div>
          <div class="col-lg-2 col-md-2 col-12 form-group form-group-dropdown">
            <input id="sec4_witness2_number" formControlName="sec4_witness2_number" placeholder="Model" type="text"
              class="form-control" (input)="enforcePrefix($event,'sec4_witness2_number')"
              (keydown)="onKeyDown($event)" />
            <label class="form__label" for="sec4_witness2_number">Telephone Number</label>
          </div>
        </div>
        <div class="form-section row customRowMrgMobile">
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <label class="form__label" for="sec4_witness2_state">State</label>
            <div class="select">
              <select id="sec4_witness2_state" formControlName="sec4_witness2_state">
                <option *ngFor="let state of states" [value]="state.code"> {{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group form-group-dropdown">
            <label class="form__label" for="sec4_witness2_city">City</label>
            <div class="select">
              <select id="sec4_witness2_city" formControlName="sec4_witness2_city">
                <option *ngFor="let city of cityMap['sec4W2Cities']" [value]="city"> {{ city }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-12 form-group">
            <input id="sec4_witness2_zipcode" formControlName="sec4_witness2_zipcode" placeholder="zip code" type="text"
              class="form-control" />
            <label class="form__label" for="sec4_witness2_zipcode">Zip Code</label>
          </div>
        </div>

        <div class="form-navigation">
          <button type="button" (click)="prevStep()" class="btn btn-secondary btn-prev">Previous</button>
          <button type="button" (click)="nextStep()" class="btn btn-primary btn-next"
            style="margin-left:25px">Next</button>
        </div>
      </div>

      <!-- Step 5 -->
      <div *ngIf="currentStep === 4" class="col-12" formGroupName="section5">
        <!--t7801my starts-->
        <div class="col-lg-6 col-md-7 col-12 form-group">
          <div *ngIf="!isMobile" class="form-row">
            <label class="main-checkbox-label">Types Of Modes:</label>
            <div class="checkbox-container">
              <label class="checkbox-item">
                <input type="radio" formControlName="auto_mode" [value]="true" (change)="onModeChange('auto')" />
                Autonomous Mode
              </label>
              <label class="checkbox-item">
                <input type="radio" formControlName="conv_mode" [value]="true" (change)="onModeChange('conv')" />
                Conventional Mode
              </label>
            </div>
          </div>
          <div *ngIf="isMobile">
            <label class="main-checkbox-label">Types Of Modes:</label>
            <div class="checkbox-container-5">
              <label class="checkbox-item-inline">
                <input type="radio" formControlName="auto_mode" [value]="true" (change)="onModeChange('auto')" />
                Autonomous Mode
              </label>
              <label class="checkbox-item-inline">
                <input type="radio" formControlName="conv_mode" [value]="true" (change)="onModeChange('conv')" />
                Conventional Mode
              </label>
            </div>
          </div>
        </div>

        <div class="form-group" style="margin-bottom: 5%;">
          <div class="wrapper">
            <label class="main-checkbox-label"  for="desc">Accident Details Description &nbsp;<span
              style="color:red">*</span></label>
              <textarea id="desc" maxlength="200" formControlName="desc" placeholder=" Enter Description" (input)="updateCharacterCount()"></textarea>
            <div id="the-count">
              <span id="current"  [ngStyle]="{ color: currentColor }"> {{currentLength}}</span>
              <span id="maximum">/ 200</span>
            </div>
          </div>
          <div class="error-msg" *ngIf="form.get('section5.desc')?.invalid && form.get('section5.desc')?.touched">
            Enter Accident Details Description
          </div>
        </div>

        <div class="col-lg-6 col-md-7 col-12 form-group ">
          <mat-accordion>
            <!--1st expansion - starts -->
            <mat-expansion-panel #panel1 [expanded]="step() === 0" (opened)="setStep(0)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Weather </mat-panel-title>
                <mat-icon>{{panel1.expanded? 'remove' : 'add'}}</mat-icon>
              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllWeather" (change)="toggleAll($event.checked, 'weather')"
                style="height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA1" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="veh1">
                  <th mat-header-cell *matHeaderCellDef> Vehicle1 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh1"
                      (change)="onMatCheckboxChange(element, 'veh1', $event, 'weather')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="veh2">
                  <th mat-header-cell *matHeaderCellDef> Vehicle2 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh2"
                      (change)="onMatCheckboxChange(element, 'veh2', $event, 'weather')"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{weatherString}}</p> -->
            <!--1st expansion - ends -->

            <!--2nd expansion - starts -->
            <mat-expansion-panel #panel2 [expanded]="step() === 1" (opened)="setStep(1)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Lighting </mat-panel-title>
                <mat-icon class="icon-right">{{panel2.expanded? 'remove' : 'add'}}</mat-icon>
              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllLightining" (change)="toggleAll($event.checked, 'lighting')"
                style="height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA2" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="veh1">
                  <th mat-header-cell *matHeaderCellDef> Vehicle1 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh1"
                      (change)="onMatCheckboxChange(element, 'veh1', $event, 'lighting')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="veh2">
                  <th mat-header-cell *matHeaderCellDef> Vehicle2 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh2"
                      (change)="onMatCheckboxChange(element, 'veh2', $event, 'lighting')"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-secondary btn-prev-acc" (click)="prevStepy()">
                  <mat-icon>navigate_before</mat-icon>
                </button>
                <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{lightingString}}</p> -->
            <!--2nd expansion - ends -->

            <!--3rd expansion - starts -->
            <mat-expansion-panel #panel3 [expanded]="step() === 2" (opened)="setStep(2)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Roadway Surface </mat-panel-title>
                <mat-icon>{{panel3.expanded? 'remove' : 'add'}}</mat-icon>
              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllRs" (change)="toggleAll($event.checked, 'roadway_surface')"
                style=" height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA3" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="veh1">
                  <th mat-header-cell *matHeaderCellDef> Vehicle1 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh1"
                      (change)="onMatCheckboxChange(element, 'veh1', $event, 'roadway_surface')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="veh2">
                  <th mat-header-cell *matHeaderCellDef> Vehicle2 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh2"
                      (change)="onMatCheckboxChange(element, 'veh2', $event, 'roadway_surface')"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-secondary btn-prev-acc" (click)="prevStepy()">
                  <mat-icon>navigate_before</mat-icon>
                </button>
                <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{rsString}}</p> -->
            <!--3rd expansion - ends -->

            <!--4th expansion - starts -->
            <mat-expansion-panel #panel4 [expanded]="step() === 3" (opened)="setStep(3)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Roadway Conditions </mat-panel-title>
                <mat-icon>{{panel4.expanded? 'remove' : 'add'}}</mat-icon>
              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllRc" (change)="toggleAll($event.checked, 'roadway_conditions')"
                style="height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA4" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="veh1">
                  <th mat-header-cell *matHeaderCellDef> Vehicle1 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh1"
                      (change)="onMatCheckboxChange(element, 'veh1', $event, 'roadway_conditions')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="veh2">
                  <th mat-header-cell *matHeaderCellDef> Vehicle2 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh2"
                      (change)="onMatCheckboxChange(element, 'veh2', $event, 'roadway_conditions')"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-secondary btn-prev-acc" (click)="prevStepy()">
                  <mat-icon>navigate_before</mat-icon>
                </button>
                <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{rcString}}</p> -->
            <!--4th expansion - ends -->

            <!--5th expansion - starts -->
            <mat-expansion-panel #panel5 [expanded]="step() === 4" (opened)="setStep(4)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Movement Preceding Collision </mat-panel-title>
                <mat-icon>{{panel5.expanded? 'remove' : 'add'}}</mat-icon>
              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllMvt" (change)="toggleAll($event.checked, 'movement')"
                style="height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA5" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="veh1">
                  <th mat-header-cell *matHeaderCellDef> Vehicle1 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh1"
                      (change)="onMatCheckboxChange(element, 'veh1', $event, 'movement')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="veh2">
                  <th mat-header-cell *matHeaderCellDef> Vehicle2 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh2"
                      (change)="onMatCheckboxChange(element, 'veh2', $event, 'movement')"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-secondary btn-prev-acc" (click)="prevStepy()">
                  <mat-icon>navigate_before</mat-icon>
                </button>
                <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{mvtString}}</p> -->
            <!--5th expansion - ends -->

            <!--6th expansion - starts -->
            <mat-expansion-panel #panel6 [expanded]="step() === 5" (opened)="setStep(5)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Type Of Collision </mat-panel-title>
                <mat-icon>{{panel6.expanded? 'remove' : 'add'}}</mat-icon>
              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllToc" (change)="toggleAll($event.checked, 'type_of_collision')"
                style="height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA6" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="veh1">
                  <th mat-header-cell *matHeaderCellDef> Vehicle1 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh1"
                      (change)="onMatCheckboxChange(element, 'veh1', $event, 'type_of_collision')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="veh2">
                  <th mat-header-cell *matHeaderCellDef> Vehicle2 </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.veh2"
                      (change)="onMatCheckboxChange(element, 'veh2', $event, 'type_of_collision')"></mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-secondary btn-prev-acc" (click)="prevStepy()">
                  <mat-icon>navigate_before</mat-icon>
                </button>
                <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{tocString}}</p> -->
            <!--6th expansion - ends -->

            <!--7th expansion - starts -->
            <mat-expansion-panel #panel7 [expanded]="step() === 6" (opened)="setStep(6)" hideToggle>
              <mat-expansion-panel-header class="header">
                <mat-panel-title> Other Associated Factors </mat-panel-title>
                <mat-icon>{{panel7.expanded? 'remove' : 'add'}}</mat-icon>

              </mat-expansion-panel-header>

              <!-- <mat-checkbox [checked]="selectAllOther" (change)="toggleAll($event.checked, 'other')"
                style="height: 25px;">Select All
              </mat-checkbox> -->

              <table mat-table [dataSource]="ELEMENT_DATA7" class="mat-elevation-z8 custom-table">
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef> #</th>
                  <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef> Types</th>
                  <td mat-cell *matCellDef="let element"> {{element.types}} </td>
                </ng-container>
                <ng-container matColumnDef="yes">
                  <th mat-header-cell *matHeaderCellDef> Yes </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="element.yes"
                      (change)="onMatCheckboxChange(element, 'yes', $event, 'other')"></mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="no">
                  <th mat-header-cell *matHeaderCellDef> No </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox *ngIf="!['B', 'C', 'D', 'E', 'F', 'G', 'I', 'J', 'K', 'L'].includes(element.id)"
                      [checked]="element.no" (change)="onMatCheckboxChange(element, 'no', $event, 'other')">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedYNColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedYNColumns;"></tr>
              </table>

              <mat-action-row>
                <button type="button" mat-button class="btn btn-secondary btn-prev-acc" (click)="prevStepy()">
                  <mat-icon>navigate_before</mat-icon>
                </button>
                <!-- <button type="button" mat-button class="btn btn-primary btn-next-acc" (click)="nextStepy()"><mat-icon>check_circle</mat-icon></button>  -->
              </mat-action-row>
            </mat-expansion-panel>
            <!-- <p style="color: white;">{{otherString}}</p> -->
            <!--7th expansion - ends -->

          </mat-accordion>
        </div>

        <div class="form-navigation">
          <button type="button" (click)="prevStep()" class="btn btn-secondary btn-prev">Previous</button>
          <button type="button" (click)="nextStep()" class="btn btn-primary btn-next"
            style="margin-left:25px">Next</button>
        </div>
      </div>

      <!-- Step preview -->
      <div *ngIf="currentStep === 5" class="col-12" formGroupName="section6">
        <div class="card-container">
          <mat-card>
            <mat-card-content>
              <!-- Section 1 - starts -->
              <div class="form-container">
                <button type="button" (click)="onEdit(0)" class="edit-btn">
                  <mat-icon title="Edit">create</mat-icon>
                </button>
                <p class="title" title="Accident Information Vehicle 1">Accident Information/Vehicle 1</p>
                <form [formGroup]="getSection('section1')">
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Acc. Date</label>
                      <label class="lab-prv" *ngIf="isMobile">Acc. Date :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('date_of_accident')?.value}">
                        {{ getSection('section1').get('date_of_accident')?.value}}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('date_of_accident')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Acc. Time</label>
                      <label class="lab-prv" *ngIf="isMobile">Acc. Time :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('time_of_accident')?.value}">
                        {{ getSection('section1').get('time_of_accident')?.value }}
                        <span *ngIf="getSection('section1').get('time_of_accident')?.value">
                          {{ getSection('section1').get('time_zone')?.value === 'AM0PM1' ? 'PM' : 'AM' }}
                        </span>
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('time_of_accident')?.value }}
                        <span *ngIf="getSection('section1').get('time_of_accident')?.value">
                          {{ getSection('section1').get('time_zone')?.value === 'AM0PM1' ? 'PM' : 'AM' }}
                        </span>
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Vehicle Year</label>
                      <label class="lab-prv" *ngIf="isMobile">Vehicle Year :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('vehicle_year')?.value}">
                        {{ getSection('section1').get('vehicle_year')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('vehicle_year')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12 ">
                      <label class="lab-prv" *ngIf="!isMobile">Make</label>
                      <label class="lab-prv" *ngIf="isMobile">Make :</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('make')?.value}">
                        {{ getSection('section1').get('make')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('make')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Model</label>
                      <label class="lab-prv" *ngIf="isMobile">Model :</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('model')?.value}">
                        {{ getSection('section1').get('model')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('model')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">License Plate</label>
                      <label class="lab-prv" *ngIf="isMobile">License Plate :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('license_plate_number')?.value}">
                        {{ getSection('section1').get('license_plate_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('license_plate_number')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">VIN</label>
                      <label class="lab-prv" *ngIf="isMobile">VIN :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('vehicle_number')?.value}">
                        {{ getSection('section1').get('vehicle_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('vehicle_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State Regd</label>
                      <label class="lab-prv" *ngIf="isMobile">State Regd :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('state_vechicle_registered')?.value}">
                        {{ getSection('section1').get('state_vechicle_registered')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('state_vechicle_registered')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Acc. Loc.</label>
                      <label class="lab-prv" *ngIf="isMobile">Acc. Loc. :</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('address')?.value}">
                        {{ getSection('section1').get('address')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('address')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12 ">
                      <label class="lab-prv" *ngIf="!isMobile">County</label>
                      <label class="lab-prv" *ngIf="isMobile">County :</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('county')?.value}">
                        {{ getSection('section1').get('county')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('county')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('state')?.value}">
                        {{ getSection('section1').get('state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">City</label>
                      <label class="lab-prv" *ngIf="isMobile">City :</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('city')?.value}">
                        {{ getSection('section1').get('city')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('city')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Zip Code</label>
                      <label class="lab-prv" *ngIf="isMobile">Zip Code :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('zip_code')?.value}">
                        {{ getSection('section1').get('zip_code')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('zip_code')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">No. of Vehicles</label>
                      <label class="lab-prv" *ngIf="isMobile">No. of Vehicles :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('vehicles_involved')?.value}">
                        {{ getSection('section1').get('vehicles_involved')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('vehicles_involved')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Vehicle was</label>
                      <label class="lab-prv" *ngIf="isMobile">Vehicle was :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('vehicle_state')?.value}">
                        {{ getLabel(vehicleState, getSection('section1').get('vehicle_state')?.value) }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getLabel(vehicleState, getSection('section1').get('vehicle_state')?.value) }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Acc. Involved</label>
                      <label class="lab-prv" *ngIf="isMobile">Acc. Involved :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('accident_involved')?.value}">
                        {{ getLabel(involvedINAccidentType, getSection('section1').get('accident_involved')?.value) }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getLabel(involvedINAccidentType, getSection('section1').get('accident_involved')?.value) }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Driver's Name</label>
                      <label class="lab-prv" *ngIf="isMobile">Driver's Name :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('driver_name')?.value}">
                        {{ getSection('section1').get('driver_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('driver_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">DL No.</label>
                      <label class="lab-prv" *ngIf="isMobile">DL No. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('driver_name')?.value}">
                        {{ getSection('section1').get('driver_license_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('driver_license_number')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('driver_state')?.value}">
                        {{ getSection('section1').get('driver_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('driver_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">D.O.B</label>
                      <label class="lab-prv" *ngIf="isMobile">D.O.B :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('date_of_birth')?.value}">
                        {{ getSection('section1').get('date_of_birth')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('date_of_birth')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Ins/Surety Co.</label>
                      <label class="lab-prv" *ngIf="isMobile">Ins/Surety Co. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('insurance_company')?.value}">
                        {{ getSection('section1').get('insurance_company')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('insurance_company')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Pol. No.</label>
                      <label class="lab-prv" *ngIf="isMobile">Pol. No. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('policy_number')?.value}">
                        {{ getSection('section1').get('policy_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('policy_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Co. NAIC No.</label>
                      <label class="lab-prv" *ngIf="isMobile">Co. NAIC No. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('naic_number')?.value}">
                        {{ getSection('section1').get('naic_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('naic_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Pol.Period From</label>
                      <label class="lab-prv" *ngIf="isMobile">Pol.Period From :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('policy_period_from')?.value}">
                        {{ getSection('section1').get('policy_period_from')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('policy_period_from')?.value }}
                      </div>
                    </div>

                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Pol.Period To</label>
                      <label class="lab-prv" *ngIf="isMobile">Pol.Period To :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('policy_period_to')?.value}">
                        {{ getSection('section1').get('policy_period_to')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section1').get('policy_period_to')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Acc. Involvement</label>
                      <label class="lab-prv" *ngIf="isMobile">Acc. Involvement :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('DESC_VEH_DAM')?.value}">
                        {{ getLabel(vehicleDamageType, getSection('section1').get('DESC_VEH_DAM')?.value) }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getLabel(vehicleDamageType, getSection('section1').get('DESC_VEH_DAM')?.value) }}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Section 1 - ends -->
              <!-- Section 2 - starts -->
              <div class="form-container">
                <button type="button" (click)="onEdit(1)" class="edit-btn">
                  <mat-icon title="Edit">create</mat-icon>
                </button>
                <p class="title">Shade Damaged Area</p>
                <form [formGroup]="getSection('section2')">
                  <div class="card car-damage-card">
                    <div class="card-body">
                      <div class="car-container">
                        <div class="car-label back-label">Back</div>
                        <div class="car-grid">
                          <div *ngFor="let row of carStructure2; let rowIndex = index" class="car-row">
                            <div *ngFor="let cell of row; let colIndex = index" class="car-cell" [ngClass]="{
                              'hidden': cell.cellValue === 0,
                              'border-top': cell.cellValue === 2,
                              'border-left': cell.cellValue === 4,
                              'border-right': cell.cellValue === 5,
                              'border-bottom': cell.cellValue === 3,
                              'border-top_left': cell.cellValue === 6,
                              'border-top_right': cell.cellValue === 7,
                              'border-bottom_left': cell.cellValue === 8,
                              'border-bottom_right': cell.cellValue === 9,
                              'border-leftmore-bottom': cell.cellValue === 10,
                              'border-leftright-top': cell.cellValue === 11,
                              'border-top-middle-rotate': cell.cellValue === 13,
                              'border-bottom-middle-rotate': cell.cellValue === 12,
                              'border-top-leftrotate': cell.cellValue === 14,
                              'border-bottom-leftrotate': cell.cellValue === 15,
                              'top-lefthalf-background-black': (colIndex === 2 || colIndex === 6) && (rowIndex === 0),
                              'top-righthalf-background-black': (colIndex === 1 || colIndex === 5) && (rowIndex === 0),
                              'bottom-lefthalf-background-black': (colIndex === 2 || colIndex === 6) && (rowIndex === 3),
                              'bottom-righthalf-background-black': (colIndex === 1 || colIndex === 2 || colIndex === 5 || colIndex === 6) && (rowIndex === 3),
                              'margin-top-adjust': colIndex === 0 || colIndex === row.length - 1,
                              'selected': cell.isChecked
                            }">
                              <!-- Render checkbox only for non-zero cell values -->
                              <input *ngIf="cell.cellValue !== 0" id="cell.label" type="checkbox" name="cell.label"
                                [checked]="cell.isChecked" [disabled]="true" />
                            </div>
                          </div>
                        </div>
                        <div class="car-label front-label">Front</div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Section 2 - ends -->
              <!-- Section 3 - starts -->
              <div class="form-container">
                <button type="button" (click)="onEdit(2)" class="edit-btn">
                  <mat-icon title="Edit">create</mat-icon>
                </button>
                <p class="title">Other Party Information/Vehicle 2</p>
                <form [formGroup]="getSection('section3')">
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Vehicle Year</label>
                      <label class="lab-prv" *ngIf="isMobile">Vehicle Year :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_vehicle_year')?.value}">
                        {{ getSection('section3').get('veh2_vehicle_year')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_vehicle_year')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Model</label>
                      <label class="lab-prv" *ngIf="isMobile">Model :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_model')?.value}">
                        {{ getSection('section3').get('veh2_model')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_model')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">License Plate</label>
                      <label class="lab-prv" *ngIf="isMobile">License Plate :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_license_plate_number')?.value}">
                        {{ getSection('section3').get('veh2_license_plate_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_license_plate_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">VIN</label>
                      <label class="lab-prv" *ngIf="isMobile">VIN :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_vehicle_number')?.value}">
                        {{ getSection('section3').get('veh2_vehicle_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_vehicle_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State Regd</label>
                      <label class="lab-prv" *ngIf="isMobile">State Regd :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_state_vechicle_registered')?.value}">
                        {{ getSection('section3').get('veh2_state_vechicle_registered')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_state_vechicle_registered')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">No. of Vehicles</label>
                      <label class="lab-prv" *ngIf="isMobile">No. of Vehicles :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_vehicles_involved')?.value}">
                        {{ getSection('section3').get('veh2_vehicles_involved')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_vehicles_involved')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Vehicle was</label>
                      <label class="lab-prv" *ngIf="isMobile">Vehicle was :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_vehicle_state')?.value}">
                        {{ getLabel(vehicleState, getSection('section3').get('veh2_vehicle_state')?.value) }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getLabel(vehicleState, getSection('section3').get('veh2_vehicle_state')?.value) }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Acc. Involved</label>
                      <label class="lab-prv" *ngIf="isMobile">Acc. Involved :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_accident_involved')?.value}">
                        {{ getLabel(involvedINAccidentType, getSection('section3').get('veh2_accident_involved')?.value)
                        }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getLabel(involvedINAccidentType, getSection('section3').get('veh2_accident_involved')?.value)
                        }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Driver's Name</label>
                      <label class="lab-prv" *ngIf="isMobile">Driver's Name :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_driver_name')?.value}">
                        {{ getSection('section3').get('veh2_driver_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_driver_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">DL No.</label>
                      <label class="lab-prv" *ngIf="isMobile">DL No. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_driver_license_number')?.value}">
                        {{ getSection('section3').get('veh2_driver_license_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_driver_license_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_driver_state')?.value}">
                        {{ getSection('section3').get('veh2_driver_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_driver_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">D.O.B</label>
                      <label class="lab-prv" *ngIf="isMobile">D.O.B :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_date_of_birth')?.value}">
                        {{ getSection('section3').get('veh2_date_of_birth')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_date_of_birth')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Ins/Surety Co.</label>
                      <label class="lab-prv" *ngIf="isMobile">Ins/Surety Co. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_insurance_company')?.value}">
                        {{ getSection('section3').get('veh2_insurance_company')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_insurance_company')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Pol. No.</label>
                      <label class="lab-prv" *ngIf="isMobile">Pol. No. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_policy_number')?.value}">
                        {{ getSection('section3').get('veh2_policy_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_policy_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Co. NAIC No.</label>
                      <label class="lab-prv" *ngIf="isMobile">Co. NAIC No. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_naic_number')?.value}">
                        {{ getSection('section3').get('veh2_naic_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_naic_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Pol.Period From</label>
                      <label class="lab-prv" *ngIf="isMobile">Pol.Period From :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_policy_period_from')?.value}">
                        {{ getSection('section3').get('veh2_policy_period_from')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_policy_period_from')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Pol.Period To</label>
                      <label class="lab-prv" *ngIf="isMobile">Pol.Period To :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('veh2_policy_period_to')?.value}">
                        {{ getSection('section3').get('veh2_policy_period_to')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section3').get('veh2_policy_period_to')?.value }}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Section 3 - ends -->
              <!-- Section 4 - starts -->
              <div class="form-container">
                <button type="button" (click)="onEdit(3)" class="edit-btn">
                  <mat-icon title="Edit">create</mat-icon>
                </button>
                <p class="title">Injurity/Death, Property Damage</p>
                <form [formGroup]="getSection('section4')">
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Name</label>
                      <label class="lab-prv" *ngIf="isMobile">Name :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person1_name')?.value}">
                        {{ getSection('section4').get('sec4_person1_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person1_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Addr</label>
                      <label class="lab-prv" *ngIf="isMobile">Addr :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person1_address')?.value}">
                        {{ getSection('section4').get('sec4_person1_address')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person1_address')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person1_state')?.value}">
                        {{ getSection('section4').get('sec4_person1_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person1_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">City</label>
                      <label class="lab-prv" *ngIf="isMobile">City :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person1_city')?.value}">
                        {{ getSection('section4').get('sec4_person1_city')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person1_city')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Zip Code</label>
                      <label class="lab-prv" *ngIf="isMobile">Zip Code :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person1_zipcode')?.value}">
                        {{ getSection('section4').get('sec4_person1_zipcode')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person1_zipcode')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Applicable</label>
                      <label class="lab-prv" *ngIf="isMobile">Applicable :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person1_injurytype')?.value}">
                        {{ getSection('section4').get('sec4_person1_injurytype')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person1_injurytype')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Name2</label>
                      <label class="lab-prv" *ngIf="isMobile">Name2 :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person2_name')?.value}">
                        {{ getSection('section4').get('sec4_person2_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person2_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Addr2</label>
                      <label class="lab-prv" *ngIf="isMobile">Addr2 :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person2_address')?.value}">
                        {{ getSection('section4').get('sec4_person2_address')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person2_address')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State2</label>
                      <label class="lab-prv" *ngIf="isMobile">State2 :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person2_state')?.value}">
                        {{ getSection('section4').get('sec4_person2_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person2_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">City2</label>
                      <label class="lab-prv" *ngIf="isMobile">City2 :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person2_city')?.value}">
                        {{ getSection('section4').get('sec4_person2_city')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person2_city')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Zip Code2</label>
                      <label class="lab-prv" *ngIf="isMobile">Zip Code2 :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person2_zipcode')?.value}">
                        {{ getSection('section4').get('sec4_person2_zipcode')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person2_zipcode')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Applicable2</label>
                      <label class="lab-prv" *ngIf="isMobile">Applicable2 :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_person2_injurytype')?.value}">
                        {{ getSection('section4').get('sec4_person2_injurytype')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_person2_injurytype')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">P.Damage</label>
                      <label class="lab-prv" *ngIf="isMobile">P.Damage :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_damage')?.value}">
                        {{ getSection('section4').get('sec4_property_damage')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_damage')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">P.O.Name</label>
                      <label class="lab-prv" *ngIf="isMobile">P.O.Name :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_name')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Tel No</label>
                      <label class="lab-prv" *ngIf="isMobile">Tel No :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_number')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Street Addr.</label>
                      <label class="lab-prv" *ngIf="isMobile">Street Addr. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_street_address')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_street_address')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_street_address')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_state')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">City</label>
                      <label class="lab-prv" *ngIf="isMobile">City :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_city')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_city')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_city')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Zip Code</label>
                      <label class="lab-prv" *ngIf="isMobile">Zip Code :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_zipcode')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_zipcode')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_zipcode')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Witness Name</label>
                      <label class="lab-prv" *ngIf="isMobile">Witness Name :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness1_name')?.value}">
                        {{ getSection('section4').get('sec4_witness1_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness1_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Street Addr.</label>
                      <label class="lab-prv" *ngIf="isMobile">Street Addr. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness1_address')?.value}">
                        {{ getSection('section4').get('sec4_witness1_address')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness1_address')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness1_state')?.value}">
                        {{ getSection('section4').get('sec4_witness1_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness1_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">City</label>
                      <label class="lab-prv" *ngIf="isMobile">City :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_property_owner_city')?.value}">
                        {{ getSection('section4').get('sec4_property_owner_city')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_property_owner_city')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Zip Code</label>
                      <label class="lab-prv" *ngIf="isMobile">Zip Code :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness1_zipcode')?.value}">
                        {{ getSection('section4').get('sec4_witness1_zipcode')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness1_zipcode')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Witness Name</label>
                      <label class="lab-prv" *ngIf="isMobile">Witness Name :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness2_name')?.value}">
                        {{ getSection('section4').get('sec4_witness2_name')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness2_name')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Street Addr.</label>
                      <label class="lab-prv" *ngIf="isMobile">Street Addr. :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness2_address')?.value}">
                        {{ getSection('section4').get('sec4_witness2_address')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness2_address')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Tel No</label>
                      <label class="lab-prv" *ngIf="isMobile">Tel No :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness2_number')?.value}">
                        {{ getSection('section4').get('sec4_witness2_number')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness2_number')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">State</label>
                      <label class="lab-prv" *ngIf="isMobile">State :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness2_state')?.value}">
                        {{ getSection('section4').get('sec4_witness2_state')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness2_state')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">City</label>
                      <label class="lab-prv" *ngIf="isMobile">City :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness2_city')?.value}">
                        {{ getSection('section4').get('sec4_witness2_city')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness2_city')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Zip Code</label>
                      <label class="lab-prv" *ngIf="isMobile">Zip Code :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('sec4_witness2_zipcode')?.value}">
                        {{ getSection('section4').get('sec4_witness2_zipcode')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section4').get('sec4_witness2_zipcode')?.value }}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Section 4 - ends -->
              <!-- Section 5 - starts -->
              <div class="form-container">
                <button type="button" (click)="onEdit(4)" class="edit-btn">
                  <mat-icon title="Edit">create</mat-icon>
                </button>
                <p class="title">Accident Details Description</p>
                <form [formGroup]="getSection('section5')">
                  <div class="form-section row sec">
                    <div class="col-lg-2 col-md-2 col-12">
                      <label class="lab-prv" *ngIf="!isMobile">Type of Mode</label>
                      <label class="lab-prv" *ngIf="isMobile">Type of Mode :</label>
                      <div *ngIf="!isMobile"
                        [ngClass]="{'empty-field': !getSection('section1').get('selected_mode')?.value}">
                        {{ getSelectedMode() || ' '}}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSelectedMode() }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12" *ngIf="isMobile">
                      <label class="lab-prv">Description :</label>
                      <div *ngIf="!isMobile">
                        {{ getSection('section5').get('desc')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section5').get('desc')?.value }}
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12 extra-space" *ngIf="!isMobile">
                      <label class="lab-prv">Description</label>
                      <div *ngIf="!isMobile" [ngClass]="{'empty-field': !getSection('section1').get('desc')?.value}">
                        {{ getSection('section5').get('desc')?.value }}
                      </div>
                      <div *ngIf="isMobile" class="line-display">
                        {{ getSection('section5').get('desc')?.value }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-7 col-12 form-group">
                    <!--1st expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Weather</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle1</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle2</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA1" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA1)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA1)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA1)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA1)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--1st expansion - ends -->

                    <!--2nd expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Lightining</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle1</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle2</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA2" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA2)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA2)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA2)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA2)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--2nd expansion - ends -->

                    <!--3rd expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Roadway Surface</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle1</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle2</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA3" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA3)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA3)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA3)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA3)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--3rd expansion - ends -->

                    <!--4th expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Roadway Cond</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle1</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle2</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA4" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA4)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA4)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA4)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA4)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--4th expansion - ends -->

                    <!--5th expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Mvt Prev Collision</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle1</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle2</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA5" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA5)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA5)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA5)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA5)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--5th expansion - ends -->

                    <!--6th expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Type Of Collision</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle1</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Vehicle2</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA6" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA6)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh1', ELEMENT_DATA6)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA6)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'veh2', ELEMENT_DATA6)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--6th expansion - ends -->

                    <!--7th expansion - starts -->
                    <div class="form-section">
                      <div class="row">
                        <div class="col-1 col-md-1">
                          <label><strong>#</strong></label>
                        </div>
                        <div class="col-6 col-md-5">
                          <label><strong>Types - Other Assoc. Fact</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>Yes</strong></label>
                        </div>
                        <div class="col-2 col-md-2">
                          <label><strong>No</strong></label>
                        </div>
                      </div>
                      <div *ngFor="let element of ELEMENT_DATA7" class="row">
                        <div class="col-1 col-md-1">
                          <div>{{element.id}}</div>
                        </div>
                        <div class="col-6 col-md-5">
                          <div>{{element.types}}</div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'yes', ELEMENT_DATA7)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'yes', ELEMENT_DATA7)">✗</span>
                          </div>
                        </div>
                        <div class="col-2 col-md-2">
                          <div>
                            <span *ngIf="isCheckboxSelected(element.types, 'no', ELEMENT_DATA7)">✓</span>
                            <span *ngIf="!isCheckboxSelected(element.types, 'no', ELEMENT_DATA7)">✗</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--7th expansion - ends -->
                  </div>
                </form>
              </div>
              <!-- Section 5 - ends -->
            </mat-card-content>
          </mat-card>
        </div>
        <div class="form-navigation">
          <button type="submit" class="btn btn-primary btn-submit" style="margin-left:25px">Submit<div
              *ngIf="isSubmitted" class="spinner-border spinner-border-sm " style="margin-left: 5%;" role="status">
              <span class="sr-only">Loading...</span>
            </div></button>
        </div>
      </div>
    </div>
  </div>
</form>

<div *ngIf="showModal" class="modal">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Wish to continue to fill the form?</h5>
      </div>
      <div class="modal-body">
        <p>Time remaining: {{ modalCountdown }}s</p>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="onContinue()" style="float: left;" class="btn btn-secondary">Yes</button>
        <button type="button" (click)="logout()" style="float: right;" class="btn btn-primary">No</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="onSubmitErrorMessage.length" class="alert alert-danger alert-dismissible fade show" role="alert">
  {{onSubmitErrorMessage}}
  <button type="button" style="top:10px;padding: 0;" class="btn-close" data-bs-dismiss="alert"
    aria-label="Close"></button>
</div>





<script src="http://thecodeplayer.com/uploads/js/prefixfree-1.0.7.js" type="text/javascript"
  type="text/javascript"></script>